// extracted by mini-css-extract-plugin
export default {"costcall":"CostcallPage_costcall__AWNmo"};